(() => {
  const starPath = 'M10 1l2.7 5.5 6.1.9-4.4 4.3 1 6.1-5.4-2.9-5.4 2.9 1-6.1L1.2 7.4l6.1-.9Z';
  const svgStars = () => `<svg viewBox="0 0 100 20" aria-hidden="true">${[0,20,40,60,80].map(x => `<path transform="translate(${x} 0)" d="${starPath}"/>`).join('')}</svg>`;
  const element = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  };
  function init(root) {
    if (root.dataset.fjrReady) return;
    const source = root.querySelector('[data-fjr-data]');
    if (!source) return;
    let data, strings;
    try {
      data = JSON.parse(source.textContent);
      strings = JSON.parse(root.querySelector('[data-fjr-strings]').textContent);
      if (!Array.isArray(data.reviews) || !Array.isArray(data.colors)) return;
    } catch { return; }
    const list = root.querySelector('[data-fjr-list]');
    const color = root.querySelector('[data-fjr-color]');
    const rating = root.querySelector('[data-fjr-rating]');
    const sort = root.querySelector('[data-fjr-sort]');
    const more = root.querySelector('[data-fjr-more]');
    const status = root.querySelector('[data-fjr-status]');
    let limit = 6;
    let shown = [];
    const dateFormatter = new Intl.DateTimeFormat(document.documentElement.lang || 'en', {year:'numeric',month:'short',day:'numeric',timeZone:'UTC'});
    const dateLabel = value => {
      const date = new Date(`${value}T00:00:00Z`);
      return Number.isNaN(date.getTime()) ? '' : dateFormatter.format(date);
    };
    data.colors.forEach(item => {
      const option = element('option', '', `${item.name} (${item.count})`);
      option.value = item.id;
      color.append(option);
    });
    function card(review) {
      const article = element('article', 'fjr-card');
      article.tabIndex = -1;
      const header = element('header');
      header.append(element('p', 'fjr-author', review.author || strings.anonymous));
      const time = element('time', 'fjr-date', dateLabel(review.date));
      time.dateTime = review.date;
      header.append(time);
      const meta = element('p', 'fjr-meta');
      [['color',review.color],['size',review.size],['inseam',review.inseam]].forEach(([key,value]) => {
        if (value) meta.append(element('span','',`${strings[key]}: ${value}`));
      });
      header.append(meta);
      const body = element('div','fjr-body');
      const stars = element('span','fjr-stars');
      stars.setAttribute('role','img');
      stars.setAttribute('aria-label',strings.rating.replace('__rating__',review.rating));
      stars.style.setProperty('--fjr-fill',`${Math.max(0,Math.min(5,review.rating))*20}%`);
      stars.innerHTML = `${svgStars()}<span>${svgStars()}</span>`;
      body.append(stars);
      if (review.title) body.append(element('h3','',review.title));
      body.append(element('p','',review.body));
      article.append(header,body);
      return article;
    }
    function render(append = false) {
      const filtered = data.reviews.filter(r => (!color.value || r.productId === color.value) && (!rating.value || r.rating === Number(rating.value)));
      filtered.sort((a,b) => {
        if (sort.value === 'highest' && a.rating !== b.rating) return b.rating-a.rating;
        if (sort.value === 'lowest' && a.rating !== b.rating) return a.rating-b.rating;
        return sort.value === 'oldest' ? a.date.localeCompare(b.date) : b.date.localeCompare(a.date);
      });
      const visible = filtered.slice(0,limit);
      const offset = append ? shown.length : 0;
      if (!append) list.replaceChildren();
      const fragment = document.createDocumentFragment();
      visible.slice(offset).forEach(r => fragment.append(card(r)));
      list.append(fragment);
      shown = visible;
      status.textContent = strings.showing.replace('__shown__',visible.length).replace('__total__',filtered.length);
      root.querySelector('[data-fjr-empty]').hidden = filtered.length > 0;
      more.hidden = visible.length >= filtered.length;
      if (append && list.children[offset]) list.children[offset].focus({preventScroll:true});
    }
    [color,rating,sort].forEach(control => control.addEventListener('change',() => {limit=6;render();}));
    more.addEventListener('click',() => {limit+=6;render(true);});
    root.querySelector('[data-fjr-reset]').addEventListener('click',() => {color.value='';rating.value='';limit=6;render();color.focus();});
    root.querySelector('[data-fjr-controls]').hidden = false;
    root.dataset.fjrReady = 'true';
    render();
    const openWriter = () => {
      if (/judgeme|jdgm|write.review/i.test(location.search + location.hash)) {
        const writer = root.querySelector('[data-fjr-write]');
        if (writer) writer.open = true;
      }
    };
    openWriter();
    window.addEventListener('hashchange',openWriter);
  }
  const boot = scope => scope.querySelectorAll('[data-fj-reviews]').forEach(init);
  boot(document);
  document.addEventListener('shopify:section:load',event => boot(event.target));
})();
